module.exports = __webpack_public_path__ + "static/img/nav.e2ac7e1b.png";